import { get, chain } from 'lodash';
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_SECTION_PROPS, GIGS_TO_SHOW } from './constants';

const OfferMoreGigsContext = React.createContext();

export const OfferMoreGigsContextProvider = ({ children }) => {
    const [loadingOfferMoreGigs, setLoadingOfferMoreGigs] = useState(false);
    const [gigsData, setGigsData] = useState(DEFAULT_SECTION_PROPS);
    const offerMoreGigsComponentRef = useRef();
    const [showMoreGigsStep, setShowMoreGigsStep] = useState(false);

    const getGigs = (data) => chain(data)
        .get('items.gigs', [])
        .uniqBy('seller_id')
        .take(GIGS_TO_SHOW)
        .value();

    const gigs = getGigs(gigsData);
    const contextEnrichment = get(gigsData, 'contextEnrichment', {});

    return (
        <OfferMoreGigsContext.Provider value={{
            updateGigsData: setGigsData,
            contextEnrichment,
            gigs,
            loadingOfferMoreGigs,
            setLoadingOfferMoreGigs,
            offerMoreGigsComponentRef,
            showMoreGigsStep,
            setShowMoreGigsStep
        }}>
            {children}
        </OfferMoreGigsContext.Provider>
    );

};

OfferMoreGigsContextProvider.propTypes = {
    children: PropTypes.node
};

export const useOfferMoreGigsContext = () => React.useContext(OfferMoreGigsContext);
